import * as React from "react";
const stats = [{
  value: "Arizona",
  label: "Golf Specialists"
}, {
  value: "Fast Turnaround",
  label: "Affordable Prices"
}, {
  value: "Part 107",
  label: "FAA Certified"
}, {
  value: "Golf-Focused",
  label: "Media"
}];
export default function ProtectionByTheNumbers() {
  return <section data-section-id="223158" id="the-trow-standard" className="bg-background text-foreground py-20 md:py-32 border-y border-primary/10">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-4 md:gap-x-0 text-center">
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center space-y-3 md:px-6 border-primary/10 last:border-r-0 md:border-r">
              <span className="text-3xl md:text-4xl lg:text-5xl font-semibold text-primary font-serif tracking-tighter">
                {stat.value}
              </span>
              <span className="text-xs md:text-sm font-medium text-muted-foreground font-sans uppercase tracking-[0.2em]">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}